import { render, staticRenderFns } from "./TarifaPetroleo.vue?vue&type=template&id=28a97cf8&"
import script from "./TarifaPetroleo.vue?vue&type=script&lang=js&"
export * from "./TarifaPetroleo.vue?vue&type=script&lang=js&"
import style0 from "./TarifaPetroleo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports